import { makeStyles } from '@material-ui/core';
import { reactStyling, tokens } from '@getgo/chameleon-core';
const useCheckboxStyles = makeStyles((theme) => {
    const { checkboxControlActive, checkboxControlHover, checkboxControlFocus, checkboxCheckedActive, checkboxControlCheckedHover, checkboxChecked, checkboxDisabledControl, checkboxDisabledCheckedControl, checkboxLarge, } = reactStyling(theme.tokens);
    return {
        rootMedium: {
            padding: 0,
            width: 16,
            height: 16,
        },
        rootLarge: {
            padding: 0,
            width: 20,
            height: 20,
        },
        icon: {
            display: 'inline-flex',
            alignItems: 'center',
            border: `1px solid ${tokens.ui03}`,
            borderRadius: 2,
            position: 'absolute',
            '--goto-icon-size': '24px',
            '--goto-icon-color': tokens.text06,
            justifyContent: 'inherit',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            'input:hover ~ &': Object.assign(Object.assign({}, checkboxControlHover), { backgroundColor: tokens.hoverTertiary }),
            'input:focus-visible ~ &': Object.assign(Object.assign({}, checkboxControlFocus), { borderColor: tokens.inverseInteractive01, boxShadow: tokens.highlight }),
            'input:active ~ &': Object.assign(Object.assign({}, checkboxControlActive), { backgroundColor: tokens.pressedTertiary }),
            'input:disabled ~ &': Object.assign({}, checkboxDisabledControl),
        },
        large: Object.assign({}, checkboxLarge),
        indeterminateIcon: Object.assign(Object.assign({}, checkboxChecked), { backgroundColor: tokens.interactive01, borderColor: tokens.interactive01, 'input:hover ~ &': Object.assign(Object.assign({}, checkboxControlCheckedHover), { backgroundColor: tokens.inverseInteractive01, borderColor: tokens.inverseInteractive01 }), 'input:focus-visible ~ &': Object.assign(Object.assign({}, checkboxControlFocus), { borderColor: tokens.inverseInteractive01, boxShadow: tokens.highlight }), 'input:active ~ &': Object.assign(Object.assign({}, checkboxCheckedActive), { backgroundColor: tokens.pressedTertiary, borderColor: tokens.pressedTertiary }), 'input:disabled ~ &': Object.assign({}, checkboxDisabledCheckedControl), '& chameleon-svg': {
                color: tokens.text06,
            } }),
        checkedIcon: Object.assign(Object.assign({}, checkboxChecked), { backgroundColor: tokens.interactive01, borderColor: tokens.interactive01, 'input:hover ~ &': Object.assign(Object.assign({}, checkboxControlCheckedHover), { backgroundColor: tokens.hoverPrimary, borderColor: tokens.hoverPrimary }), 'input:focus-visible ~ &': Object.assign(Object.assign({}, checkboxControlFocus), { borderColor: tokens.inverseInteractive01, boxShadow: tokens.highlight }), 'input:active ~ &': Object.assign(Object.assign({}, checkboxCheckedActive), { backgroundColor: tokens.pressedPrimary, borderColor: tokens.pressedPrimary }), 'input:disabled ~ &': Object.assign({}, checkboxDisabledCheckedControl), '& chameleon-svg': {
                color: tokens.text06,
            } }),
        label: {
            cursor: 'pointer',
            userSelect: 'none',
            marginLeft: 8,
            display: 'inline-flex',
        },
        disabled: {
            pointerEvents: 'none',
            color: tokens.text03,
        },
    };
});
export default useCheckboxStyles;
